<template>
  <div
    class="bg-white p-4 rounded-2xl border border-gray-100 flex items-center gap-4 cursor-pointer active:bg-gray-50"
    @click="openPixelDrawer"
  >
    <div class="w-12 h-12 rounded-xl border border-gray-100 flex items-center justify-center bg-white flex-shrink-0 p-2">
      <i class="pi pi-facebook text-2xl text-blue-500"></i>
    </div>
    <div class="flex-1 min-w-0 text-right">
      <h3 class="font-bold text-gray-900 text-base">Meta Pixel</h3>
      <p class="text-xs text-gray-500 leading-snug mt-0.5">מעקב המרות ופרסום ממוקד בפייסבוק</p>
    </div>
    <div>
      <div v-if="isConnected" class="flex items-center gap-1.5 text-green-600 bg-green-50 px-3 py-1.5 rounded-full border border-green-100">
        <span class="text-xs font-bold">מחובר</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </div>
      <span v-else class="text-xs font-bold bg-gray-100 text-gray-700 px-4 py-1.5 rounded-full">חבר</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { useAdminStore } from '@app/stores';
import { useDrawer } from '@torim-app/shared-components';

const adminStore = useAdminStore();
const { openDrawer } = useDrawer();

const isConnected = computed(() => !!adminStore.getBusinessSiteData?.configurations?.metaPixelId);

const openPixelDrawer = () => {
  const MarketingTools = defineAsyncComponent(() =>
    import('@app/components/admin/pages/configurations/MarketingTools.vue')
  );
  openDrawer(MarketingTools, {}, { title: 'Meta Pixel' });
};
</script>
